export const OFFER_CHAINS = [
    { id: 'kaufland-cz', label: 'Kaufland', country: 'CZ', currency: 'CZK', source: 'kaufland', match: ['kaufland'], keyword: 'kaufland', storeRegions: true },
    { id: 'tesco-cz', label: 'Tesco', country: 'CZ', currency: 'CZK', source: 'ai', match: ['tesco'], keyword: 'tesco', formatVariants: true },
    { id: 'albert-cz', label: 'Albert', country: 'CZ', currency: 'CZK', source: 'ai', match: ['albert'], keyword: 'albert', formatVariants: true },
    { id: 'billa-cz', label: 'Billa', country: 'CZ', currency: 'CZK', source: 'ai', match: ['billa'], keyword: 'billa' },
    { id: 'lidl-cz', label: 'Lidl', country: 'CZ', currency: 'CZK', source: 'ai', match: ['lidl'], keyword: 'lidl' },
    { id: 'coop-cz', label: 'COOP (Střední Čechy)', country: 'CZ', currency: 'CZK', source: 'ai', match: ['coop'], keyword: 'coop' },
    { id: 'penny-cz', label: 'Penny', country: 'CZ', currency: 'CZK', source: 'penny', match: ['penny'], keyword: 'penny' },
    { id: 'biedronka-pl', label: 'Biedronka', country: 'PL', currency: 'PLN', source: 'blix', match: ['biedronka'], keyword: 'biedronka', counterVariants: true },
    { id: 'lidl-pl', label: 'Lidl (Polsko)', country: 'PL', currency: 'PLN', source: 'blix', match: ['lidl'], keyword: 'lidl' },
    { id: 'kaufland-pl', label: 'Kaufland (Polsko)', country: 'PL', currency: 'PLN', source: 'blix', match: ['kaufland'], keyword: 'kaufland' },
    { id: 'netto-pl', label: 'Netto (Polsko)', country: 'PL', currency: 'PLN', source: 'blix', match: ['netto'], keyword: 'netto' },
    { id: 'aldi-pl', label: 'Aldi (Polsko)', country: 'PL', currency: 'PLN', source: 'blix', match: ['aldi'], keyword: 'aldi' },
    { id: 'dino-pl', label: 'Dino', country: 'PL', currency: 'PLN', source: 'blix', match: ['dino'], keyword: 'dino' },
    { id: 'carrefour-pl', label: 'Carrefour', country: 'PL', currency: 'PLN', source: 'blix', match: ['carrefour'], keyword: 'carrefour' },
    { id: 'kaufland-de', label: 'Kaufland (Německo)', country: 'DE', currency: 'EUR', source: 'kaufland', match: ['kaufland'], keyword: 'kaufland', storeRegions: true },
    { id: 'netto-de', label: 'Netto (Německo)', country: 'DE', currency: 'EUR', source: 'marktguru', match: ['Netto Marken-Discount'], keyword: 'netto' },
    { id: 'lidl-de', label: 'Lidl (Německo)', country: 'DE', currency: 'EUR', source: 'marktguru', match: ['Lidl'], keyword: 'lidl' },
    { id: 'penny-de', label: 'Penny (Německo)', country: 'DE', currency: 'EUR', source: 'marktguru', match: ['PENNY'], keyword: 'penny' },
    { id: 'rewe-de', label: 'REWE', country: 'DE', currency: 'EUR', source: 'marktguru', match: ['REWE', 'REWE Center'], keyword: 'rewe' },
    { id: 'aldi-de', label: 'Aldi (Německo)', country: 'DE', currency: 'EUR', source: 'marktguru', match: ['ALDI Nord', 'ALDI SÜD'], keyword: 'aldi' },
    { id: 'rossmann-de', label: 'Rossmann (Německo)', country: 'DE', currency: 'EUR', source: 'marktguru', match: ['ROSSMANN'], keyword: 'rossmann' },
    { id: 'edeka-de', label: 'EDEKA', country: 'DE', currency: 'EUR', source: 'marktguru', match: ['EDEKA'], keyword: 'edeka' },
];
export const OFFER_CHAIN_IDS = OFFER_CHAINS.map((c) => c.id);
/** PSC, pro ktere se nactou nemecke akce, kdyz obchod vlastni nema (Zittau). */
export const DEFAULT_DE_ZIP = '02763';
/** Cislo prodejny Kauflandu, treba CZ3150 (Podebrady) nebo DE2950 (Zittau). */
export const KAUFLAND_STORE_PATTERN = /^(CZ|DE)\d{4}$/;
/** Zname mesto -> PSC, at se u navrhu obchodu nemusi psat rucne. */
const ZIP_BY_CITY = {
    zittau: '02763',
    gorlitz: '02826',
    'görlitz': '02826',
    lobau: '02708',
    'löbau': '02708',
    dresden: '01067',
};
export function offerChain(id) {
    return OFFER_CHAINS.find((c) => c.id === id) ?? null;
}
/** Retezec podle nazvu a meny obchodu: „Kaufland Zittau" v EUR -> kaufland-de. */
export function guessOfferChain(name, currency) {
    const words = name.toLocaleLowerCase('cs-CZ').split(/[^\p{L}\p{N}]+/u);
    const chain = OFFER_CHAINS.find((c) => c.currency === currency && words.includes(c.keyword));
    return chain?.id ?? null;
}
export function guessOfferZip(city) {
    if (!city)
        return null;
    return ZIP_BY_CITY[city.trim().toLocaleLowerCase('de-DE')] ?? null;
}
/**
 * Region, ze ktereho se akce obchodu berou: PSC u nemeckych (marktguru),
 * prodejna u Kauflandu (prazdny = akce vychozi prodejny; u starsiho obchodu
 * PSC, ze ktereho se prodejna dohleda), jinak celostatni.
 * `offerZip` obchodu nese PSC i cislo prodejny.
 */
export function offerRegion(chain, offerZip) {
    if (chain.source === 'marktguru')
        return offerZip ?? DEFAULT_DE_ZIP;
    if (chain.storeRegions)
        return offerZip ?? '';
    return '';
}
/** Klic sberu v offer_sources. Jeden sber marktguru slouzi vsem nemeckym retezcum v okoli PSC. */
export function offerSourceKey(chain, region) {
    if (chain.source === 'marktguru')
        return `marktguru:${region}`;
    if (chain.storeRegions)
        return `${chain.id}:${region || 'vychozi'}`;
    return `${chain.source}:${chain.match[0] ?? chain.id}`;
}
//# sourceMappingURL=chains.js.map